// extracted by mini-css-extract-plugin
export default {"external_link":"ExternalLink_external_link__2Uhp3"};